import React from 'react';
import { View, StyleSheet, StyleProp, ViewStyle } from 'react-native';

import { DIVIDER } from '../constants/colors';

type Props = {
  style?: StyleProp<ViewStyle>;
};

export default function Divider(props: Props) {
  let { style } = props;

  return <View style={[styles.divider, style]}></View>;
}

const styles = StyleSheet.create({
  divider: {
    width: '100%',
    height: 1,
    backgroundColor: DIVIDER.line,
  },
});
